import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import ReactTooltip from 'react-tooltip'
import { withRouter } from 'react-router-dom'
import Classnames from 'classnames'
import { library } from '@fortawesome/fontawesome-svg-core'
import Modal from 'react-responsive-modal'
import {
  deletePersonalStrategy,
  showPersonalStrategy,
  showAllStrategies,
  showStrategyEditor
} from '../../../actions/data'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  formatDate,

  getKeyMetrics,
  getKeyMetricsSymbols
} from '../../../common'
import './StrategyRow.css'
import StrategyAnalysis from './StrategyAnalysis.js'
import { KEY_METRICS } from './StrategyList.js'
import i18n from './../../../i18n'
import {
  faFilePdf,
} from '@fortawesome/free-solid-svg-icons'
//import FactSheetDownload from './FactSheetDownload.js'

library.add(
  faFilePdf,
)

class StrategyRow extends PureComponent {
  static defaultProps = {
    saveInProgress: false,
    openMenu: false,
    striped: false
  }

  constructor(props) {
    super(props)
    this.handleDeleteClick = this.handleDeleteClick.bind(this)
    this.handleCloseDeleteModal = this.handleCloseDeleteModal.bind(this)
    this.handleDeleteConfirmation = this.handleDeleteConfirmation.bind(this)
    this.handleMenuClick = this.handleMenuClick.bind(this)
    this.handleShowEditor = this.handleShowEditor.bind(this)
    this.handleOptimizeInDpd = this.handleOptimizeInDpd.bind(this)
    this.handleBreadcrumbClick = this.handleBreadcrumbClick.bind(this)

    // Initialize local state
    this.state = {
      startDeletion: false,
      openMenu: this.props.openMenu
    }
  }


  //need to track openMenu for the stinkin tabs


  componentDidUpdate(prevProps) {
    // Check if openMenu prop has changed
    if (this.props.openMenu !== prevProps.openMenu) {
      // If openMenu has changed, set menuIsOpen to the same value
      this.props.setMenuIsOpen(this.props.openMenu);
    }
  }
  // Handle delete button click
  handleDeleteClick() {
    this.setState({
      startDeletion: true
    })
  }

  // Handle close of delete modal
  handleCloseDeleteModal() {
    this.setState({
      startDeletion: false
    })
  }

  // Handle delete confirmation
  handleDeleteConfirmation(idToDelete) {
    this.setState({
      startDeletion: false
    })
    this.props.deletePersonalStrategy(idToDelete)
  }

  // Handle menu button click
  handleMenuClick(idToShow) {
    // If the menu isn't open then show the given Strategy, otherwise show all
    !this.props.openMenu
      ? this.props.showPersonalStrategy(idToShow)
      : this.props.showAllStrategies()
  }

  // Handle the show editor and pass in the personalStrategy
  handleShowEditor(strategyToEdit) {
    this.props.showStrategyEditor(strategyToEdit)
  }

  // Handle the optimization with DPD
  handleOptimizeInDpd(strategyToOptimize) {
    this.props.showAllStrategies()
    window.location = '#dpd&portfolioid=' + strategyToOptimize
  }

  // Handle the optimization with DPD
  handleRefreshData(strategyToOptimize) {
    this.props.showAllStrategies()
    window.location = '#dpd&portfolioid=' + strategyToOptimize.latestAnalysis.id
  }
  // Handle View in Fund Char
  handleViewInFundChar = (strategyToOptimize) => {
    this.props.showAllStrategies();
    window.location = '#fundchar&landingTab=3';
  }
  // Scroll to the target of the breadcrumb click
  handleBreadcrumbClick(breadcrumb) {
    let nav = document.getElementById(breadcrumb)

    if (nav) {
      nav.scrollIntoView({
        block: 'center',
        behavior: 'smooth'
      })
    }
  }

  render() {
    const { personalStrategy, saveInProgress, striped, openMenu } = this.props
    const strategyType = personalStrategy.customUserModel ? 'custom' : 'standard'
    const latestAnalysis = personalStrategy.latestAnalysis
    const metricsValues =
      latestAnalysis && latestAnalysis.statistics
        ? getKeyMetrics(personalStrategy.latestAnalysis.statistics)
        : null
    const metricsSymbols = latestAnalysis ? getKeyMetricsSymbols() : null

    return (
      <div>
        <div
          className={Classnames(
            'strategyrow',
            { striped: striped && !openMenu },
            { opened: openMenu }
          )}
        >
          <div
            className='menu'
            onClick={this.handleMenuClick.bind(this, personalStrategy.id)}
          >
            <FontAwesomeIcon
              icon='bars'
              data-tip
              data-for={'click-to-view-details-tooltip' + personalStrategy.id}
            />
          </div>
          <ReactTooltip
            key={'click-to-view-details-tooltip' + personalStrategy.id}
            id={'click-to-view-details-tooltip' + personalStrategy.id}
            type='light'
            className='tooltip'
            effect='float'
          >
            {openMenu
              ? i18n.t('click-to-go-back-to-list-tooltip')
              : i18n.t('click-to-view-details-tooltip')}
          </ReactTooltip>

          <div
            className='name'
            onClick={this.handleMenuClick.bind(this, personalStrategy.id)}
          >
            {personalStrategy.name}
          </div>

          {/* Show last updated date if the menu isnt open */}
          {!openMenu ? (
            <div className='last-updated' onClick={this.handleMenuClick.bind(this, personalStrategy.id)}>
              {formatDate(personalStrategy.updateDate)} {/*  i propose time stamp is over kill */}
            </div>
          ) : null}

          {/* If a save is in progress then the analysis will be empty */}
          {/* {console.log('latestAnalysis?.statistics:', latestAnalysis?.statistics)}
          {console.log('openMenu:', openMenu)} */}
          {!openMenu ? (
            <div className='statistics'>
              {/* Write out the metrics */}
              {/* {console.log('KEY_METRICS:', KEY_METRICS)} */}
              {KEY_METRICS.map(metric => {
                // Get the value of the current metric
                const value = metricsValues ? metricsValues[metric] : null;
                return (
                  <div key={'stat-' + metric} className={'stat-' + metric}>
                    <span
                      className='center-dash'
                      data-tip={value ? 'This data is available after 3 months from inception of this custom model.' : ''}
                      data-for={metric + '-tooltip-' + personalStrategy.id}
                    >
                      {/* If the value exists, render it. Otherwise, render a dash */}
                      {value ? value : '-'}
                      {/* If the value for this specific metric is truthy and not a dash, render the corresponding symbol */}
                      {value && value !== '-' && <span className='symbol'>{metricsSymbols[metric]}</span>}
                    </span>
                    <ReactTooltip
                      id={metric + '-tooltip-' + personalStrategy.id}
                      className='tooltip'
                      type='light'
                      effect='float'
                    >
                      {!value ? 'This data is available after 3 months from inception of this custom model.' : ''}
                    </ReactTooltip>
                  </div>
                )
              })}
            </div>
          ) :
            latestAnalysis && openMenu ? (
              // Show buttons
              <div className='statistics open-menu'>
                {/* <div className='card-breadcrumbs'>
                  <div className='breadcrumb-link breadcrumbs-separator' onClick={this.handleBreadcrumbClick.bind(this, 'key-metrics')}>
                    {i18n.t('key-metrics-title')}
                  </div>
                  <div className='breadcrumb-link breadcrumbs-separator' onClick={this.handleBreadcrumbClick.bind(this, 'performance-chart')}>
                    {i18n.t('performance')}
                  </div>
                  <div className='breadcrumb-link breadcrumbs-separator' onClick={this.handleBreadcrumbClick.bind(this, 'income-chart')}>
                    {i18n.t('income')}
                  </div>
                  <div className='breadcrumb-link' onClick={this.handleBreadcrumbClick.bind(this, 'sector-exposures')}>
                    {i18n.t('exposures')}
                  </div>
                </div> */}

                <div className='select_button_action'>

                  <button onClick={this.handleViewInFundChar.bind()} data-tip data-for={'fund-compare-tooltip'}>
                    {i18n.t('fund-comparison')}
                  </button>
                  <button onClick={this.handleOptimizeInDpd.bind(this, personalStrategy.id)} data-tip data-for={'optimize-in-dpd-tooltip'}>
                    {i18n.t('optimize-in-dpd')}
                  </button>
                  <button onClick={this.handleMenuClick.bind(this, personalStrategy.id)} data-tip data-for={'back-to-list-tooltip'}>{i18n.t('back-to-list')}</button>
                  {/* <FactSheetDownload /> */}

                  <ReactTooltip key={'back-to-list-tooltip'} id={'back-to-list-tooltip'} type='light' className='tooltip' effect='float'>
                    {i18n.t('back-to-list-tooltip')}
                  </ReactTooltip>
                  <ReactTooltip key={'optimize-in-dpd-tooltip'} id={'optimize-in-dpd-tooltip'} type='light' className='tooltip' effect='float'>
                    {i18n.t('optimize-in-dpd-tooltip')}
                  </ReactTooltip>
                  <ReactTooltip key={'fund-compare-tooltip'} id={'fund-compare-tooltip'} type='light' className='tooltip' effect='float'>
                    {i18n.t('fund-compare-tooltip')}
                  </ReactTooltip>

                </div>

              </div>
            ) : (
              <div className='statistics' />
            )}

          {/* If there is a save in progress for this strategy then show the waiting icon, otherwise show buttons */}
          {!saveInProgress ? (
            <div className='menu-buttons'>

              {/* only render edit for standard strategy */}
              {strategyType !== 'custom' ? (
                <div className='menu-button' onClick={this.handleShowEditor.bind(this, personalStrategy)}>
                  <FontAwesomeIcon icon='edit' size='lg' />
                </div>
              ) : null}
              <div className='menu-button' onClick={this.handleDeleteClick}>
                <div className='cross'>
                  <strong>✕</strong>
                </div>
              </div>
            </div>
          ) : (
            <div className='waiting'></div>
          )}

          {/* If the user clicks the delete button then pop up a modal to confirm */}
          {this.state.startDeletion ? (
            <Modal
              open={this.state.startDeletion === true}
              onClose={this.handleCloseDeleteModal}
              showCloseIcon={false}
              classNames={{
                overlay: 'modal-overlay',
                modal: 'delete-modal',
                closeIcon: 'custom-closeIcon'
              }}
              center
            >
              <div>
                <br />
                {i18n.t('confirm-delete')}
                <strong>{personalStrategy.name}</strong>?<br />
                <br />
                <div className='align-right'>
                  <button
                    onClick={this.handleDeleteConfirmation.bind(
                      this,
                      personalStrategy.id
                    )}
                  >
                    {i18n.t('delete')}
                  </button>
                  <button onClick={this.handleCloseDeleteModal}>
                    {i18n.t('cancel')}
                  </button>
                </div>
              </div>
            </Modal>
          ) : null}
        </div>
        {/* Open the Analysis dropout if the user clicks the menu button */}
        {this.props.openMenu ? (
          <StrategyAnalysis
            personalStrategy={personalStrategy}
            openHoldingsEditor={this.handleShowEditor.bind(this, personalStrategy)}
          />
        ) : null}
      </div>
    )
  }
}

export default withRouter(
  connect(null, {
    deletePersonalStrategy,
    showPersonalStrategy,
    showAllStrategies,
    showStrategyEditor
  })(StrategyRow)
)
